export default {
  OPEN_MEMBER_CARD: 'notification/OPEN_MEMBER_CARD',
  CLOSE_MEMBER_CARD: 'notification/CLOSE_MEMBER_CARD',
  SET_EXERCISES_LIST: 'SET_EXERCISES_LIST',
  SET_MEMBERSHIP: 'SET_MEMBERSHIP',
  UPDATE_DUE: 'UPDATE_DUE',
  gql: {
    GET_EXERCISES: `
      query GetExercises(
        $golfId: String!
        $accountId: String
      ) {
        getExercises(
          golfId: $golfId
          accountId: $accountId
        ) {
          subscriptionAllowed
          globalPayment {
            options
            scheduleStartDate
            scheduleDeadlineDate
            caseOptions {
              option
              scheduleStartDate
              scheduleDeadlineDate
            }
          }
          exercises {
            year
            memberships {
              reference
              year
              createdAt
              period {
                from
                to
              }
              payment {
                options
                scheduleStartDate
                scheduleDeadlineDate
                caseOptions {
                  option
                  scheduleStartDate
                  scheduleDeadlineDate
                }
              }
              members {
                tid
                firstName
                lastName
                category
                lines {
                  name
                  amount
                  type
                  isPayableInInstallments
                  options {
                    option
                    amount
                  }
                }
              }
              total {
                amount
                paid
                due
                options {
                  option
                  amount
                }
              }
              paymentSchedule {
                date
                amount
                status
              }
            }
          }
        }
      }
    `,
    SET_MEMBERSHIP_SCHEDULE: `
      mutation SetMembershipSchedule(
        $amount: Int!
        $year: String!
        $title: String!
        $golfId: String!
        $reference: String!
        $creditCardId: String!
        $paymentSchedule: [MembershipScheduleItem]!
        $skipWS: Boolean
        $accountId: String
      ) {
        setMembershipSchedule(
          year: $year
          title: $title
          amount: $amount
          golfId: $golfId
          skipWS: $skipWS
          accountId: $accountId
          reference: $reference
          creditCardId: $creditCardId
          paymentSchedule: $paymentSchedule
        ) {
          reference
        }
      }
    `,
    SET_MEMBERSHIP_PAYMENT: `
      mutation SetMembershipPayment(
        $golfId: String!
        $year: String!
        $title: String!
        $reference: String!
        $transaction: MembershipPaymentTransactionInput!
        $accountId: String
      ) {
        setMembershipPayment(
          golfId: $golfId
          year: $year
          title: $title
          reference: $reference
          transaction: $transaction
          accountId: $accountId
        ) {
          reference
          transaction {
            amount
            callNo
            transactionNo
            card
          }
        }
      }
    `,
    GET_MEMBERSHIPS: `
      query GetMemberships($golfId: String!) {
        getMemberships(golfId: $golfId) {
          main {
            code
            name
            options {
              code
              period
              price
            }
          }
          additional {
            code
            name
            required
            options {
              code
              period
              price
            }
          }
          accessories {
            code
            name
            price
          }
        }
      }
    `,
    SUBSCRIBE: `
      mutation SubscribeMembership(
        $golfId: String!
        $periodCode: String!
        $main: MembershipCode!
        $additional: [MembershipCode]!
        $accessories: [MembershipCode]!
      ) {
        subscribeMembership(
          main: $main
          golfId: $golfId
          periodCode: $periodCode
          additional: $additional
          accessories: $accessories
        ) {
          success
        }
      }
    `,
    CHECK_MEMBERSHIP_SCHEDULE: `
      query CheckMembershipSchedule(
        $golfId: String!
        $accountId: String!
        $reference: String!
      ) {
        checkMembershipSchedule(
          golfId: $golfId
          accountId: $accountId
          reference: $reference
        ) {
          reference
          amount
          createdAt
          frequency
        }
      }
    `,
  },
};
